<template>
	<div class="QYYS">
		<div class="content ys">
			<div class="content_2 c3 lh7">
				<div class="f30">企业优势</div>
				<div class="f20 mb45">SERVICE ADVANTAGES</div>
				<transition name="el-fade-in-linear">
					<div v-show="show" style="transition: all 1s;-webkit-transition: all 1s;">

						<div class="title">经验丰富</div>
						<el-row :gutter="10">
							<template v-for="(item, i) in ys">
								<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-if="i < 3">
									<div class="item mb40">
										<el-image class="big" style="width: 100%; height: 625px;vertical-align: bottom;"
											:src="item.big" :fit="'cover'"></el-image>
										<div class="item_content zzz">
											<div>
												<div class="tz">
													<el-image style="width: auto; height: auto;vertical-align: bottom;"
														:src="item.small" :fit="'cover'"></el-image>
													<div class="f24 ff b mt35 name">{{item.name}}</div>
													<div class="html f18 lh7 ff">
														<div class="pb50"></div>{{item.html}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</el-col>
							</template>
						</el-row>
						
					</div>
				</transition>
			</div>
		</div>
		<div class="f5" style="padding-bottom: 65px;">
			<div class="title">技术支持</div>
			<div class="content ys2">
				<div class="content_2">
					<el-row :gutter="10">
						<template v-for="(item, i) in ys">
							<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-if="i >= 3">
								<div class="item mb40">
									<el-image class="big" style="width: 100%; height: 625px;vertical-align: bottom;"
										:src="item.big" :fit="'cover'"></el-image>
									<div class="item_content zzz">
										<div>
											<div class="tz">
												<el-image style="width: auto; height: auto;vertical-align: bottom;"
													:src="item.small" :fit="'cover'"></el-image>
												<div class="f24 ff b mt35 name">{{item.name}}</div>
												<div class="html f18 lh7 ff">
													<div class="pb50"></div>{{item.html}}
												</div>
											</div>
										</div>
									</div>
								</div>
							</el-col>
						</template>
					</el-row>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				ys: [{
						name: '多年的服务经验',
						html: `在整车产前物流、产中物流、模块分装、工序外包服务领域有多年的服务经验。与一汽集团蔚山工厂、一汽集团动力总成工厂、一汽解放青岛工厂、一汽解放无锡柴油机厂、中国中车、天际汽车等客户合作，可以满足不同客户对工厂物流及生产管理的需求。`,
					},
					{
						name: '成熟的服务体系',
						html: `熟知整车产前、产中物流服务及模块装配、生产线分装的管理制度与作业流程，并在该物流服务领域已经建立了成熟的服务体系。`,
					},
					{
						name: '经验丰富的管理人员',
						html: `各项目部储备有物流服务工作经验丰富的管理人员，能够迅速抽调至 新业务。`,
					},
					{
						name: '多年物流规划经验',
						html: `有多年物流规划服务经验，能够提供物流服务整体方案设计、物流资源需求设计与测算、物流过程管理规划与设计、物流服务改善方案设计等服务，能够配合客户对项目不断的进行优化和改善。`,
					},
					{
						name: '科技物流服务企业',
						html: `2018年，公司开始向智慧型、科技型物流服务企业转型，专注于物流管理信息系统研发、工业机器人与智能物流装备的研发生产与集成服务、生产与物流智能化改造等相关服务领域。2019年6月，公司与掌握全球一流移动机器人控制系统的瑞典科尔摩根自动化公司签订了战略联盟合作协议，目前已获得自动导引车辆及系统的技术授权许可、软件使用。目前公司自主研发的WMS系统及移动运输机器人已正式投入公司服务项目的实际应用。`,
					},
					{
						name: '高新技术企业认证',
						html: `公司获得了12个软件著作权和1个发明专利，于2020年通过了高新技术企业认证。`,
					},
				]
			}
		},
		created() {
			this.ys.forEach((x, i) => {
				x.big = require(`../../assets/About_ys_big_${i+1}.jpg`);
				x.small = require(`../../assets/About_ys_small_${i+1}.png`);
			})
		},
		mounted() {
			this.$nextTick(() => {
				this.show = true
			})
		},
		methods: {

		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/theme.scss';

	.QYYS {

		.ys {
			padding-top: 65px;
			font-size: 18px;
			color: #404040;

			@media screen and (max-width: 768px) {
				.f30 {
					font-size: 7vw;
					line-height: 1.2;
					text-align: center;
					margin-bottom: 20px;
				}

				.f20 {
					font-size: 16px;
					text-align: center;
					line-height: 1.2;
					margin-bottom: 30px;
				}

				.f18 {
					font-size: 16px;
				}

				padding: 65px 2vw 2vw;
				box-sizing: border-box;
			}
		}
		
		.ys2 {
			@media screen and (max-width: 768px) {
				padding: 0 2vw;
				box-sizing: border-box;
			}
		}

		.item {
			// cursor: default;
			position: relative;
			overflow: hidden;

			.big img {
				transition: all 0.3s;
			}
			
			.item_content {
				position: absolute;
				z-index: 4;
				left: 0;
				top: 0;
				bottom: 0;
				right: 0;
				
				.html {
					margin: 0 8%;
					height: 0;
					transition: all 0.3s;
					-webkit-transition: all 0.3s;
					opacity: 0;
					margin-top: 0;
				}
			}
			
			&::after {
				position: absolute;
				content: ' ';
				z-index: 2;
				left: 0;
				top: 0;
				bottom: 0;
				right: 0;
				background-color: rgba(0,0,0,0.3);
				opacity: 0;
				transition: all 0.3s;
				-webkit-transition: all 0.3s;
			}

			&:hover {
				.big img {
					transform: scale(1.05);
				}
				.item_content {
					.html {
						height: 280px + 50;
						opacity: 1;
						// margin-top: 50px;
					}
				}
				&::after {
					opacity: 1;
				}
			}

			@media screen and (max-width: 768px) {
				margin-bottom: 20px;

				.f28 {
					font-size: 20px;
					padding: 16px 0;
				}
				
				.big img {
					transform: scale(1.05);
				}
				.item_content {
					.html {
						height: auto!important;
						margin: 0 4vw!important;
						opacity: 1;
						margin-top: 25px!important;
						font-size: 17px!important;
						.pb50 {
							padding-bottom: 0px;
						}
					}
				}
				&::after {
					opacity: 1;
				}
				
			}
		}
	}
</style>
